/**
 * Um `resource` pode declarar várias permissões separadas por "|" (lógica OR),
 * exatamente como o backend faz no middleware
 * `can:permissoes, 'CONF_A|CONF_B', 'read'`.
 *
 * O caso real: a tela de Empresas (empresaCliente) é liberada tanto pela
 * configuração de concessionária (CONF_MODELO_CONCESSIONARIA) quanto pela de
 * auto-agendamento (CONF_AUTOAGENDAMENTOPREENCHEREMPRESA). A rota já aceitava
 * as duas, mas o menu e a busca comparavam a string inteira com o ability —
 * que nunca casa — e o item sumia para quem só tinha a primeira ativada.
 */

/** Quebra 'A|B' em ['A', 'B']; string simples vira lista de um item. */
export const listarResources = (resource) => String(resource ?? '')
    .split('|')
    .map((r) => r.trim())
    .filter(Boolean)

/**
 * `true` se QUALQUER um dos resources passar no teste.
 * @param {Function} can - função de checagem (this.$can, ability.can, …)
 * @param {String} action - read, create, update, delete
 * @param {String} resource - 'A' ou 'A|B'
 */
export const podeAlgumResource = (can, action, resource) => {
    const resources = listarResources(resource)
    if (!resources.length) return can(action, resource)

    return resources.some((r) => can(action, r))
}

/** Primeiro resource da lista que satisfaz o predicado (ou null). */
export const acharResource = (resource, predicado) => listarResources(resource)
    .find((r) => predicado(r)) || null

export default { listarResources, podeAlgumResource, acharResource }
